import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "82.222 0 280.373 444.818",
  "content": "<symbol viewBox=\"82.222 0 280.373 444.818\" id=\"icon-arrow-right\">\r\n<g>\r\n\t<path d=\"M352.025,196.712L165.884,10.848C159.029,3.615,150.469,0,140.187,0c-10.282,0-18.842,3.619-25.697,10.848L92.792,32.264\r\n\t\tc-7.044,7.043-10.566,15.604-10.566,25.692c0,9.897,3.521,18.56,10.566,25.981L231.544,222.41L92.786,361.167\r\n\t\tc-7.042,7.043-10.564,15.604-10.564,25.693c0,9.896,3.521,18.563,10.564,25.98l21.7,21.412\r\n\t\tc7.043,7.043,15.612,10.564,25.697,10.564c10.089,0,18.656-3.521,25.697-10.564L352.025,248.39\r\n\t\tc7.047-7.424,10.57-16.084,10.57-25.981C362.597,212.321,359.072,203.755,352.025,196.712z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/arrow-right.svg
// module id = Qsna
// module chunks = 0